// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"482":"d46a54b9ee72a15a7db9","655":"42ac28e384441c92c5ca"}[chunkId] + ".js");